export const GET_TOKENS = 'GET_TOKENS';
export const SET_TOKENS = 'SET_TOKENS';

export const SET_AGREEMENT_TOKENS = 'SET_AGREEMENT_TOKENS';
export const SET_VAULT_TOKENS = 'SET_VAULT_TOKENS';

export const SET_TOKENS_LOADING_FALSE = 'SET_AGREEMENTS_LOADING_FALSE';
